import { Box, Dialog, Flex, Grid, Text, IconButton } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { CloseIcon } from 'shared/icons';
import { ManagePlan } from '../types';

import './manage-plan-card.scss';

const ManagePlanCardView = ({ plan }: { plan: ManagePlan }) => {
   return (
      <Box className="manager-card">
         <Flex justify="between" align="baseline">
            <Dialog.Title color="orange">{plan.plan_name}</Dialog.Title>

            <Dialog.Close>
               <IconButton size="1" color="gray">
                  <CloseIcon width={20} height={20} />
               </IconButton>
            </Dialog.Close>
         </Flex>

         <Box py="2">
            <Grid columns="200px 1fr" gap="3" width="auto">
               <Text weight="bold">Amount:</Text>
               <Text>{plan.amount}</Text>
               <Text weight="bold">Plan Type:</Text>
               <Text>{plan.type}</Text>
               <Text weight="bold">Time Period:</Text>
               <Text>{plan.type_value}</Text>
            </Grid>
         </Box>

         <Box mt="2" overflow="hidden">
            <Text weight="bold">Features:</Text>
            <ol className="manage-plan__features">
               {plan.features.map((feature, idx) => {
                  return <li key={idx}>{feature}</li>;
               })}
            </ol>
         </Box>
      </Box>
   );
};

export const ManagePlanCard = observer(ManagePlanCardView);
